import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Title + Stats */}
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-8 leading-tight">
              Why Choose Our<br />VigorBuy Spreadsheet?
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, idx) => (
                <div key={stat.label} className={idx < 3 ? 'md:border-r md:border-background-200/70 md:pr-6' : ''}>
                  <p className="text-2xl md:text-4xl font-heading font-bold text-primary-500 mb-1">{stat.value}</p>
                  <p className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Decorative Image Wall */}
          <div className="flex-1 w-full hidden lg:block">
            <div className="relative h-[400px] bg-accent-100/50 rounded-2xl overflow-hidden p-6">
              <div className="absolute top-4 left-4 w-32 h-32 rounded-xl overflow-hidden bg-background-200/40 rotate-3">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20single%20limited%20edition%20sneaker%20on%20a%20dark%20polished%20wooden%20display%20stand%2C%20dramatic%20side%20lighting%20creating%20depth%2C%20premium%20product%20photography%2C%20rich%20contrast%2C%20no%20text%20or%20logos&width=300&height=300&seq=stat-new-01-sneaker&orientation=squarish"
                  alt="VigorBuy sneaker showcase"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-20 right-6 w-40 h-40 rounded-xl overflow-hidden bg-background-200/40 -rotate-6">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20designer%20crossbody%20bag%20on%20a%20light%20travertine%20surface%2C%20bright%20natural%20sunlight%20through%20a%20nearby%20window%2C%20modern%20editorial%20product%20photography%2C%20sharp%20details%2C%20no%20text%20or%20logos&width=300&height=300&seq=stat-new-02-bag&orientation=squarish"
                  alt="VigorBuy designer bag"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-10 left-10 w-36 h-36 rounded-xl overflow-hidden bg-background-200/40 rotate-2">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20luxury%20wristwatch%20on%20a%20dark%20slate%20surface%20with%20soft%20golden%20backlighting%2C%20premium%20product%20photography%2C%20elegant%20minimal%20composition%2C%20metallic%20reflections%2C%20no%20text%20or%20logos&width=300&height=300&seq=stat-new-03-watch&orientation=squarish"
                  alt="VigorBuy luxury watch"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-20 right-10 w-28 h-28 rounded-full overflow-hidden bg-background-200/40 -rotate-3">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20pair%20of%20designer%20sunglasses%20on%20a%20reflective%20glass%20surface%2C%20bright%20natural%20daylight%2C%20minimalist%20product%20photography%2C%20crisp%20lens%20reflection%2C%20no%20text%20or%20logos&width=300&height=300&seq=stat-new-04-glasses&orientation=squarish"
                  alt="VigorBuy designer sunglasses"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-40 left-32 w-24 h-24 rounded-lg overflow-hidden bg-background-200/40 rotate-12">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20delicate%20silver%20ring%20on%20a%20dark%20velvet%20surface%2C%20soft%20spotlight%20from%20above%2C%20macro%20product%20photography%2C%20intricate%20details%20visible%2C%20no%20text%20or%20logos&width=300&height=300&seq=stat-new-05-ring&orientation=squarish"
                  alt="VigorBuy silver ring"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}